import React from "react";
import { ChatPlayer } from "@42maru/webchat";
import { MediaType } from "@/model/paragraph/paragraphData";
import ClickableImg from "@/component/ClickableImg";


interface MediaPreviewProps {
    mediaType: MediaType;
    mediaUrl: string;
    width?: number | string;
    height?: number | string;
}

const MediaPreview: React.FC<MediaPreviewProps> = (props) => {
    const { mediaType, mediaUrl, width, height } = props;

    try {
        new URL(mediaUrl);
    } catch {
        return null;
    }
    return (
        <div data-prevent-sortable="true"
             className="w-fit"
        >
            {(mediaType === "image" || mediaType === "image_square") &&
                <ClickableImg src={mediaUrl}
                              alt={mediaType}
                              square={mediaType === "image_square"}
                              width={width}
                              height={height}
                />
            }
            {(mediaType === "video" || mediaType === "audio") &&
                <ChatPlayer type={mediaType}
                            url={mediaUrl}
                            width={width}
                            height={height}
                />
            }
        </div>
    );
};

export default MediaPreview;
